import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faInfoCircle, faCheckDouble } from '@fortawesome/free-solid-svg-icons'

const FsdsaiPersonalized = (props) => {
  const {
    immersivePrice,
    personalizedPrice,
    numOfAssignments,
    numOfHours,
    numOfMentorshipMinutes,
  } = props;

  const showCourses = () => {
    document.getElementById("courseList").style.display = "block";
    document.getElementById("expandCourses").style.display = "none";
  }

  return (
    <>
      <div className="flex-grow-1">
        <ul className="list-unstyled pl-0 mb-0">
          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />Everything in Front-end and Back-end</li>
          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />{immersivePrice.attributes.num_of_courses} Courses <span onClick={showCourses} id="expandCourses"><u>(Show All)</u></span></li>

          <ul id="courseList" style={{ display: 'none' }} className="list-unstyled pl-0">
            <li><i className="fas mr-2 fa-sm fa-fw" ariaHidden="true"></i>– HTML CSS Development</li>
            <li><i className="fas mr-2 fa-sm fa-fw" ariaHidden="true"></i>– JavaScript Programming</li>
            <li><i className="fas mr-2 fa-sm fa-fw" ariaHidden="true"></i>– Dynamic Website Development</li>
            <li><i className="fas mr-2 fa-sm fa-fw" ariaHidden="true"></i>– ReactJS Development</li>
            <li><i className="fas mr-2 fa-sm fa-fw" ariaHidden="true"></i>– Ruby Programming</li>
            <li><i className="fas mr-2 fa-sm fa-fw" ariaHidden="true"></i>– Ruby on Rails</li>
            <li><i className="fas mr-2 fa-sm fa-fw" ariaHidden="true"></i>– Full-stack Deployment</li>
            <li><i className="fas mr-2 fa-sm fa-fw" ariaHidden="true"></i>– Python and Automation</li>
            <li><i className="fas mr-2 fa-sm fa-fw" ariaHidden="true"></i>– Data Science</li>
            <li><i className="fas mr-2 fa-sm fa-fw" ariaHidden="true"></i>– Applied AI</li>
          </ul>

          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />Instant Ask and Chat <FontAwesomeIcon icon={faInfoCircle} data-tip="Get professional answers for any questions you might have while learning." data-for="DatesAndTuition" /></li>
          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />Q&A Database <FontAwesomeIcon icon={faInfoCircle} data-tip="Search and find historical questions and answers." data-for="DatesAndTuition" /></li>
          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />Curriculum Written by Industry Experts</li>
          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />Assignments and Code Reviews by Mentors</li>
          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />{numOfAssignments} assignments and projects</li>
          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />{numOfHours} hours of learning</li>
          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />GitHub Student Developer Pack (Worth $500+)</li>
          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />Lifetime Access</li>
        </ul>
      </div>
      <div className="pt-1">
        <div className="mb-2"><b>Exclusive in Personalized:</b></div>
        <ul className='list-unstyled pl-0 mb-0 personalizedFeature'>
          <li><FontAwesomeIcon icon={faCheckDouble} size="sm" className="mr-2" fixedWidth />1-on-1 Video-Call Mentorship ({numOfMentorshipMinutes} minutes) <FontAwesomeIcon icon={faInfoCircle} data-tip="We offer private 1-on-1 Office-hours over online video chat with our Mentors, so you can get real-time support when you need it. We cover most of the world's timezones." data-for="DatesAndTuition" /></li>
          <li><FontAwesomeIcon icon={faCheckDouble} size="sm" className="mr-2" fixedWidth />Career Guidance</li>
          <li><FontAwesomeIcon icon={faCheckDouble} size="sm" className="mr-2" fixedWidth />Interview Preparations</li>
          <li><FontAwesomeIcon icon={faCheckDouble} size="sm" className="mr-2" fixedWidth />Interview Questions Database</li>
          <li><FontAwesomeIcon icon={faCheckDouble} size="sm" className="mr-2" fixedWidth />Final Capstone Portfolio Project</li>
        </ul>
      </div>
      <div className="pt-1">
        <div className="mb-2"><b>2 Complementary Courses in Personalized:</b></div>
        <ul className='list-unstyled pl-0 mb-0 personalizedFeature'>
          <li><FontAwesomeIcon icon={faCheckDouble} size="sm" className="mr-2" fixedWidth />Data Structures & Algorithms Course</li>
          <li><FontAwesomeIcon icon={faCheckDouble} size="sm" className="mr-2" fixedWidth />TypeScript Course</li>
          {/* <li><FontAwesomeIcon icon={faCheckDouble} size="sm" className="mr-2" fixedWidth />Tailwind CSS Course</li> */}
        </ul>
      </div>
    </>
  );
}

export default FsdsaiPersonalized;
